"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkSensorV2 = exports.updateAllPhysicsTick = exports.render = exports.create = exports.get = void 0;
var diveColors_1 = require("@dive/colors/diveColors");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var minigolfCamera_sidecar_1 = require("../camera/minigolfCamera-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var minigolfPhysics_rapier_loader_sidecar_1 = require("../physics/minigolfPhysics_rapier_loader-sidecar");
var spritesPieces_1 = require("../recyclers/spritesPieces");
var minigolfRenderer_sidecar_1 = require("../renderer/minigolfRenderer-sidecar");
var namespace = 'placer-sensor';
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            rigidBody: null,
        };
    }
    return _obj;
};
exports.get = get;
var create = function () {
    var phys = minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.get();
    var RA = phys.RA, world = phys.world;
    var placerSensorRadius = minigolfDefs_sidecar_1.minigolfDefs.placerSensorRadius, puckRadius = minigolfDefs_sidecar_1.minigolfDefs.puckRadius;
    var placerSensor_rigidBodyDesc = RA.RigidBodyDesc.fixed().setTranslation(0.0, 0.0);
    var placerSensor_rigidBody = world.createRigidBody(placerSensor_rigidBodyDesc);
    var placerSensor_colliderDesc = RA.ColliderDesc.ball(puckRadius).setSensor(true);
    // .setCollisionGroups(CollisionGroups.playarea)
    var placerSensor_collider = world.createCollider(placerSensor_colliderDesc, placerSensor_rigidBody);
    placerSensor_rigidBody.userData = { type: 'placer' };
    exports.get().rigidBody = placerSensor_rigidBody;
};
exports.create = create;
var render = function () {
    if (!minigolfDefs_sidecar_1.minigolfDefs.debug_placerSensor) {
        return;
    }
    // Check sensor
    var hasCollision = exports.checkSensorV2();
    var sensorColor = diveColors_1.diveColors.darkBlue;
    if (hasCollision) {
        sensorColor = diveColors_1.diveColors.red;
    }
    var scaling = 78 / 121;
    var pos = minigolfRenderer_sidecar_1.minigolfRenderer.getPhysicsPosition(exports.get().rigidBody);
    var sprite = spritesPieces_1.spritesPieces.getNext(pos.x, pos.y, sprites_sidecar_1.sprites.crokinoleDiscPlain[0]);
    sprite.tint = sensorColor; // player.color
    // sprite.rotation = -rotation
    sprite.scale = sprite.scale * scaling;
};
exports.render = render;
var updateAllPhysicsTick = function () {
    var cursor = minigolfCamera_sidecar_1.minigolfCamera.getUiMousePosition();
    var physicsCursor = minigolfCamera_sidecar_1.minigolfCamera.worldToPhysics(cursor.mx, cursor.my);
    exports.get().rigidBody.setTranslation({ x: physicsCursor.x, y: physicsCursor.y }, true);
};
exports.updateAllPhysicsTick = updateAllPhysicsTick;
// export const checkSensorV1 = () => {
//   if (!minigolfDefs.debug_placerSensor) {
//     return
//   }
//   // Note: this doesn't seem to work with fixed items like boundaries?
//   let phys = minigolfPhysics_rapier_loader.get()
//   let obj = get()
//   let hasCollision = false
//   // phys.world.intersectionsWith
//   phys.world.intersectionPairsWith(obj.rigidBody.collider(0), (coll2) => {
//     console.log('sensor hit', coll2)
//     if (coll2.collisionGroups() === minigolfDefs.CollisionGroups.none) {
//       return // Ignore
//     }
//     hasCollision = true
//     // see: https://rapier.rs/docs/user_guides/javascript/advanced_collision_detection_js
//     // console.log(namespace, 'sensor hit', otherCollider)
//     //sensorColor = diveColors.red
//   })
//   return hasCollision
// }
var checkSensorV2 = function () {
    var phys = minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.get();
    var obj = exports.get();
    var sensorShape = obj.rigidBody.collider(0).shape; // new RAPIER.(1.0, 2.0);
    // let shapePos = { x: 1.0, y: 2.0 }
    // let shapeRot = 0.1
    var hasCollision = false;
    phys.world.intersectionsWithShape(obj.rigidBody.translation(), obj.rigidBody.rotation(), sensorShape, function (handle) {
        // if (handle.isSensor()) {
        //   return true
        // }
        var parent = handle.parent();
        if (!(parent === null || parent === void 0 ? void 0 : parent.userData)) {
            // Skip if no user data
            hasCollision = true;
            return true;
        }
        var userData = parent.userData;
        var type = (userData === null || userData === void 0 ? void 0 : userData.type) || 'unknown';
        if (type === 'placer') {
            // Ignore
            return true;
        }
        // Ignore if no collision groups
        if (parent.collider(0).collisionGroups() ===
            minigolfDefs_sidecar_1.minigolfDefs.CollisionGroups.none) {
            return true;
        }
        // console.log('The collider', handle, 'intersects our shape.')
        hasCollision = true;
        return false; // Return `false` instead if we want to stop searching for other colliders that contain this point.
    });
    return hasCollision;
};
exports.checkSensorV2 = checkSensorV2;
